import React from "react";


export default function FilterBar({ children }) {
  return (
    <div className="filter-bar-ui">
      {children}
    </div>
  );
}